<script lang="ts">
  import { ToolbarSearch } from 'carbon-components-svelte';
  import { onMount, onDestroy, createEventDispatcher } from 'svelte';
  import debounce from 'lodash/debounce';

  export let searchText: string;
  export let persistent: boolean;
  export let placeholder: string = 'Search...';

  const DEBOUNCE_MS = 500;
  const MAX_FILTER_LENGTH = 128;

  const dispatch = createEventDispatcher<{ toolbarSearchValueInit: never; toolbarSearchValueChange: string }>();

  const onToolBarValueChange = ({ target }: Event) => {
    dispatch('toolbarSearchValueChange', (target as HTMLInputElement)?.value);
  };

  const handlePopstate = () => {
    const url = new URL(window.location.href);
    searchText = url.searchParams.get('filter') || '';
  };

  const synchronizeFilter = (isInitial: boolean) => {
    const url = new URL(window.location.href);
    const urlFilter = (url.searchParams.get('filter') || '').substring(0, MAX_FILTER_LENGTH);

    if (isInitial) {
      searchText = urlFilter;
      return;
    }
    if (searchText?.length > MAX_FILTER_LENGTH) {
      searchText = searchText.substring(0, MAX_FILTER_LENGTH);
    }
    if (typeof searchText !== 'string') {
      searchText = '';
    }

    if (searchText === '' && urlFilter !== '') {
      url.searchParams.delete('filter');
      updateUrlAndPageHistory(url);
    } else if (urlFilter !== searchText) {
      url.searchParams.set('filter', searchText);
      updateUrlAndPageHistory(url);
    }
  };

  const updateUrlAndPageHistory = debounce((url: URL) => window.history.pushState({}, '', url), DEBOUNCE_MS);

  synchronizeFilter(true);

  onMount(() => dispatch('toolbarSearchValueInit'));

  onDestroy(() => updateUrlAndPageHistory.cancel());

  // Update filter, searchText variable used to trigger update
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  $: searchText, synchronizeFilter(false);
</script>

<svelte:window on:popstate={handlePopstate} />

<ToolbarSearch {placeholder} {persistent} bind:value={searchText} on:clear={onToolBarValueChange} on:input={onToolBarValueChange} />
